class SlackService {
    sendToSlack(payload) {
        console.log('PAYLOAD', payload);
        fetch(`${process.env.API_URL}/api/slack/feedback`, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ payload }),
        }).then(res => {
            console.log('RES', res);
            // The `onSubmit` prop function is called with the SlackFeedback component
            // context (this.props.onSubmit.call(this, payload)), meaning the component
            // methods are available from this function. You should call the `sent`
            // method if the request was successfully sent to Slack.
            this.sent();
        }, error => {
            this.error(error.statusText);
        });
    }
}
export default new SlackService();



// WEBPACK FOOTER //
// ./src/services/slack.service.js